<script>
  import inview from '#lib/inview.js';
  import { generate_css_variables } from '#lib/util.js';

  let {
    children, 
    id,
    onpointerup,
    onpointerdown,
    onpointerenter,
    onpointerleave,
    onclick,
    ondblclick,
    color,
    class: css_class,
    /** @type {[number,number]} tracks 1-17 */
    tracks = [1,-1],
    /** @type {boolean} enable intersection observer */
    observe_inview = true,
    /** @type {boolean} observe only once */
    observe_inview_once = false,
    /** @type {number[]} inview thresholds - only [0.2, 0.8] used by story-block animations */
    inview_threshold = [0.2, 0.8],
    /** @type {string|null} CSS anchor name for positioning */
    anchor_name = null,
    /** @type {HTMLElement} Bindable reference to the DOM element */
    element = $bindable(null),
  } = $props();
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<!-- svelte-ignore a11y_no_static_element_interactions -->

<!-- TODO: remove inview once we have Block level animations 
  and there's cross browser support for css scroll driven animations -->
<!-- A static <section>, not <svelte:element this={tag}>: Svelte 5 (still in 5.57) re-inserts
     a svelte:element into the DOM while hydrating (`anchor.before(element)` runs even for the
     claimed SSR node), which cancels and restarts every CSS animation inside it. On a cold
     load that hydrates after first paint, every block-level intro animation played once,
     hid, and played again - the slideshow's settle-in was the visible case. -->
<section
  bind:this={element}
  use:inview={{
    active: observe_inview,
    once: observe_inview_once,
    threshold: inview_threshold,
  }}
  {id}
  class='block {css_class}'
  style='{generate_css_variables(color)}'
  style:anchor-name={anchor_name}
  data.color={color}
  style:--tracks='{tracks[0]} / {tracks[1]}'
  style:cursor='inherit'
  role="button"
  tabindex="-1"
  {onclick}
  {onpointerup}
  {onpointerdown}
  {onpointerenter}
  {onpointerleave}
  {ondblclick}
>
  {#if children}
    {@render children()}
  {/if}
</section>

<style lang="postcss">  
  .block {
    /* CSS Performance Boost for layout containment */
    /* DISABLED THIS again as it breaks scroll to behavior on back navigation */
    /* See: https://github.com/michael/system606/issues/750 */
    /* content-visibility: auto; */
    outline: none; /* hide default focus outline caused by role="button" */
    display: grid;
    position: relative;
    grid-template-columns: inherit;
    column-gap: inherit;
    grid-column: 1 / -1;
    scroll-margin-block-start: var(--dynamic-island-bottom-edge);
    color: var(--color-body, var(--color-default-foreground));    
  }
</style>